<template>
  <div>
    <van-sticky>
      <nav-bar class="home-nav">
        <div slot="left" @click="onClickLeft">返回</div>
        <!--    <div slot="center">教师管理({{ countTeacher }})</div>-->
        <div slot="center">俱乐部管理({{ countClub }})</div>
        <div v-if="this.$cookies.get('user') === 'admin' " slot="right" @click="deleteStudentShow=true">删除</div>
      </nav-bar>

      <van-cell v-if="authority" size="large" title="添加俱乐部" is-link to="AddClub"/>
    </van-sticky>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        loading-text="努力加载中"
      >
        <van-swipe-cell v-for="item in clubs" :key="item.id">
          <template slot="left">
            <van-button square type="primary" @click="Download(item.id,item.title)" text="下载"/>
            <van-button square type="warning" @click="modifyClub(item)" text="修改"/>
            <van-button square type="info" @click="Statistics(item.id,item.title)" text="统计"/>
          </template>
          <van-cell :border="false" :label="'负责教师:'+item.tName"
                    :title="item.title" value="<<滑动<<"/>
          <template slot="right">
            <van-button v-if="authority" square type="danger" @click="delClub(item.id)"
                        text="删除"/>
            <van-button square type="info" @click="ClubMember(item.id,item.title)" text="成员"/>
            <van-button square type="primary" @click="lookClub(item.id)" text="介绍"/>
          </template>
        </van-swipe-cell>

      </van-list>
    </van-pull-refresh>

    <van-action-sheet v-model="descriptionShow" :title="this.title+' 俱乐部介绍'">
      <van-notice-bar left-icon="volume-o">
        开放加入时间' {{ new Date(parseInt(this.startTime)).toLocaleString() }}
      </van-notice-bar>
      <van-notice-bar wrapable color="#1989fa" background="#ecf9ff" left-icon="info-o">
        <p>俱乐部最大人数：{{ this.maxp }},当前人数：{{ this.ClubPeopleCount }},</p>
        <p>俱乐部位置：{{ this.location }}</p>
      </van-notice-bar>
      <div style="padding: 16px 16px 70px;font-size: 18px;font-family: 楷体;">{{ this.description }}</div>

      <div style="padding-top: 50px"></div>
    </van-action-sheet>

    <van-dialog v-model="deleteStudentShow" title="删除俱乐部学生" confirmButtonText="删除" show-cancel-button
                @confirm="deleteStudents" :show-confirm-button="deleteStudentsCount!=0">
      <van-divider content-position="left">删除对象年级</van-divider>
      <van-radio-group @change="deleteStudentsChange" class="checkbox-group" v-model="gradeValue"
                       direction="horizontal">
        <van-radio class="checkbox" :name="item" v-for="(item,index) in grades" :key="index">{{
            item
          }}
        </van-radio>
      </van-radio-group>

      <van-divider content-position="left">删除对象学历层次</van-divider>
      <van-radio-group @change="deleteStudentsChange" style="margin-bottom: 30px" class="checkbox-group"
                       v-model="levelValue"
                       direction="horizontal">
        <van-radio class="checkbox" checked-color="#8cc269" :name="item" v-for="(item,index) in level"
                   :key="index">{{
            item
          }}
        </van-radio>
      </van-radio-group>
      <van-divider content-position="center">{{ gradeValue }} {{ levelValue }} {{ deleteStudentsCount }}人</van-divider>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  getClubList,
  DelClubById,
  GetClubCountById,
  GetClubDetailById,
  GetClubDetailDownLoad,
  CountStudentByConditions,
  DelStudentByConditions
} from "../../../network/club";
import {
  List,
  PullRefresh,
  Cell,
  SwipeCell,
  Button,
  Search,
  Dialog,
  Toast,
  Sticky,
  ActionSheet,
  NoticeBar,
  Divider,
  RadioGroup, Radio
} from 'vant';
import NavBar from "components/common/navbar/NavBar";
import {GetCourseScoreDownLoad} from "../../../network/course";

Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Cell);
Vue.use(SwipeCell);
Vue.use(Button);
Vue.use(Search);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(Sticky);
Vue.use(ActionSheet);
Vue.use(NoticeBar);
Vue.use(Divider);
Vue.use(RadioGroup);
Vue.use(Radio);
export default {
  name: "ClubList",
  components: {NavBar},
  data() {
    return {
      slide: "< < <",
      clubs: [],
      //refresh
      refreshing: false,
      loading: false,
      finished: true,

      //ActionSheet
      descriptionShow: false,
      title: "",
      location: "",
      startTime: "",
      description: "",
      //根据club id得出的这个club的人数
      ClubPeopleCount: 0,
      maxp: 0,

      countClub: 0,

      deleteStudentShow: false,
      gradeValue: '',
      grades: ['2021', '2020', '2019', '2018', '2017'],
      levelValue: '',
      level: ['本科', '专科', '专升本'],
      deleteStudentsCount: 0,
    }
  },
  mounted() {
    let t = false;
    this.IntervalId = setInterval(() => {
      if (t) {
        this.slide = '<-<-<';
        t = !t;
      } else {
        this.slide = '-<-<-';
        t = !t;
      }
    }, 400);

  },
  destroyed() {
    clearInterval(this.IntervalId);
  },
  activated() {
    this.getClubLists();
    const years = this.GLOBAL.years;
    this.grades = [];
    for (let i = 0; i < 6; i++) {
      this.grades.push(years - i);
    }

  },
  computed: {
    authority() {
      return this.$cookies.get('user') === 'admin';
    }
  },
  methods: {
    //refresh
    onLoad() {
      setTimeout(() => {
        this.refreshing = false;
        Toast('刷新成功');
      }, 1500);
    },
    onRefresh() {
      // 清空列表数据;
      this.clubs = [];
      // 将 loading 设置为 true，表示处于加载状态
      //this.loading = true;
      this.onLoad();
      setTimeout(() => {
        // 重新加载数据
        this.getClubLists();
        this.isLoading = false;
      }, 1000);
    },
    getClubLists() {
      getClubList().then(res => {
        this.clubs = [];
        this.countClub = res.length;
        this.clubs.push(...res);
      });
    },
    delClub(id) {
      Dialog.confirm({
        title: '警告',
        message: '确定要删除吗,删除俱乐部,所有选择此俱乐部的同学，将从此俱乐部退出。'
      }).then(() => {
        DelClubById(id).then(res => {
            if (res) {
              this.clubs = this.clubs.filter(item => item.id != id);
              Toast.success('刪除成功');
            } else {
              Toast.fail('删除失败');
            }
          }
        ).catch(res => {
          Toast.fail('删除失败');
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    Download(id, title) {
      GetClubDetailDownLoad(id).then(res => {
        const content = res
        const blob = new Blob([content])
        let date = new Date();
        const fileName = date.getFullYear() + "_" + (date.getMonth() + 1) + "_" + date.getDate() + "_" + title + '.xlsx'
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      }).catch(err => {
        console.log(err);
        Dialog.alert({
          message: '下载文件出错',
        });
      })
    },
    Statistics(id, title) {
      this.$router.push({path: 'ClubStatistics', query: {cid: id, title: title}})
    },
    ClubMember(id, title) {
      this.$router.push({path: 'ClubMember', query: {cid: id, title: title}})
    },
    lookClub(id) {

      let club = this.clubs.filter(item => item.id === id)[0];
      GetClubCountById(id).then(res => {
        this.ClubPeopleCount = res;
      });
      GetClubDetailById(id).then(res => {
        this.location = res.location;
        this.description = res.des;
      })
      this.title = club.title;
      this.startTime = club.startTime;
      this.maxp = club.maxp;
      this.descriptionShow = true;
    },
    onClickLeft() {
      this.$router.replace("/home");
    },
    modifyClub(item) {
      if (this.$cookies.get("user") !== "admin") {
        Toast.fail('管理员可操作');
        return;
      }
      this.$router.push({path: 'ModifyClub', query: {id: item.id}})
    },
    deleteStudents() {
      const gradeValue = this.gradeValue;
      const levelValue = this.levelValue;
      Dialog.confirm({
        title: '提示',
        message: `确定要删除${gradeValue}${levelValue} ${this.deleteStudentsCount}人吗`
      }).then(() => {
        // on confirm
        DelStudentByConditions(gradeValue, levelValue).then(res => {
          if (res) {
            Toast.success('刪除成功');
          } else {
            Toast.fail('删除失败');
          }
        })
      }).catch(() => {
        // on cancel
      });

    },
    deleteStudentsChange() {
      const gradeValue = this.gradeValue;
      const levelValue = this.levelValue;
      CountStudentByConditions(gradeValue, levelValue).then(res => {
        this.deleteStudentsCount = res;
      })
    }
  }
}
</script>

<style scoped>
.checkbox-group {
  padding: 0 20px;
}

.checkbox {
  margin: 0 0 5px 5px;
}
</style>
